import { get, post } from '../Services/http';
import { catchError } from './Error.action';
import { showLoader, hideLoader } from '../Actions/Loader.action';

export const FAVORITELISTS_RECEIVE_DATA = 'FAVORITELISTS_RECEIVE_DATA';
export const FAVORITELISTS_RECEIVE_IDS = 'FAVORITELISTS_RECEIVE_IDS';
export const FAVORITELISTS_ADDED_ITEM = 'FAVORITELISTS_ADDED_ITEM';
export const FAVORITELISTS_REMOVED_ITEM = 'FAVORITELISTS_REMOVED_ITEM';
export const FAVORITELISTS_ERROR = 'FAVORITELISTS_ERROR';

export const setError = (error) => ({
    type: FAVORITELISTS_ERROR,
    payload: {
        error,
    },
});

export const receiveData = (data) => ({
    type: FAVORITELISTS_RECEIVE_DATA,
    payload: {
        data,
    },
});

const receiveIds = (ids) => ({
    type: FAVORITELISTS_RECEIVE_IDS,
    payload: {
        ids,
    },
});

const added = (variantId) => ({
    type: FAVORITELISTS_ADDED_ITEM,
    payload: {
        variantId,
    },
});

const removed = (variantId) => ({
    type: FAVORITELISTS_REMOVED_ITEM,
    payload: {
        variantId,
    },
});

export const getFavoriteListData = () => (dispatch) => {
    dispatch(showLoader());
    dispatch(getFavoriteListIds());
    return get('/api/favoritelists/current/display') // Get the favorite lists for the current user
        .then((response) => response.json())
        .then((result) => {
            dispatch(receiveData(result));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const getFavoriteListIds = () => (dispatch) => {
    return get('/api/favoritelists/current/ids')
        .then((res) => res.json())
        .then((ids) => {
            dispatch(receiveIds(ids)); // ids is string[] or []
        });
};

export const addFavorite = (articleNumber) => (dispatch) => {
    return post('/api/favoritelists/current/add', { articleNumber })
        .then((res) => res.json())
        .then((body) => {
            if (body === true || body?.success === true) {
                dispatch(added(articleNumber));
            }
        });
};

export const removeFavorite = (articleNumber) => (dispatch) => {
    return post('/api/favoritelists/current/remove', { articleNumber })
        .then((res) => res.json())
        .then((body) => {
            if (body === true || body?.success === true) {
                dispatch(removed(articleNumber));
            }
        });
};
